import React, { useState, useEffect } from 'react';
import { Button } from '../dynamic-form/base/Button/Button';
import styles from './OtpPopup.module.scss';
import { OtpInput } from '../../../pages/loan-application';

interface OtpPopupProps {
    message: string;
    onComplete: (code: string) => void;
    onClose: () => void;
}

export const OtpPopup: React.FC<OtpPopupProps> = ({ message, onComplete, onClose }) => {
    const [countdown, setCountdown] = useState(170);
    const [otpCode, setOtpCode] = useState('');

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [countdown]);

    const handleResend = () => {
        setCountdown(170);
        // onResend(); // Resend logic to be implemented
    };

    const formatTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>

                {/* Logo */}
                <div className={styles.logo}>
                    <img
                        src="/icon-login.svg"
                        alt="Yemeksepeti"
                    />
                </div>

                {/* Başlık */}
                <h2 className={styles.title}>Yemeksepeti</h2>

                {/* Açıklama */}
                <p className={styles.message}>
                    {message || "Doğrulama kodu içeren sms gönderildi."}
                </p>

                {/* OTP Input */}
                <div className={styles.inputWrapper}>
                    <input
                        type="text"
                        value={otpCode}
                        onChange={(e) => setOtpCode(e.target.value)}
                        placeholder="Doğrulama kodu"
                    />
                </div>

                {/* Timer */}
                <div className={styles.timer}>
                    {countdown}
                </div>

                {/* Giriş */}
                <Button
                    type="button"
                    variant="primary"
                    className={styles.loginBtn}
                    onClick={() => onComplete(otpCode)}
                >
                    Giriş Yap
                </Button>

                {/* Süre bitince göster */}
                {countdown === 0 && (
                    <button
                        type="button"
                        className={styles.resendBtn}
                        onClick={handleResend}
                    >
                        Tekrar Gönder
                    </button>
                )}

            </div>
        </div>
    );
};
